<template>
  <v-container
    id="data-tables"
    tag="section"
  >
    <base-v-component
      heading="Операции по счету"
      link="components/data-tables"
    />

    <base-material-card
      color="primary"
      icon="mdi-file-document"
      inline
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          Операции по счету
        </div>
      </template>
      <v-data-table
        :headers="headers"
        :items="items"
        :search.sync="search"
        multi-sort
        show-expand
      >
        <template v-slot:top>
          <v-card flat>
            <v-card-text>
              <v-row>
                <v-col cols="3">
                  <v-text-field
                    v-model="form.date_create.from"
                    label="Дата создания от"
                    type="date"
                    @keyup.enter="load"
                  />
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    v-model="form.date_create.to"
                    label="Дата создания до"
                    type="date"
                    @keyup.enter="load"
                  />
                </v-col>
                <v-col cols="6">
                  <v-select
                    v-model="form.direction"
                    label="Тип операции"
                    :items="select.direction"
                    clearable
                    @keyup.enter="load"
                  />
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    v-model="form.description"
                    label="Назначение"
                    @keyup.enter="load"
                  />
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    v-model="form.debet"
                    label="Плательщик"
                    @keyup.enter="load"
                  />
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    v-model="form.credit"
                    label="Получатель"
                    @keyup.enter="load"
                  />
                </v-col>
                <v-col cols="2">
                  <v-text-field
                    v-model="form.min_sum"
                    label="Сумма от"
                    type="number"
                    clearable
                    @keyup.enter="load"
                  />
                </v-col>
                <v-col cols="2">
                  <v-text-field
                    v-model="form.max_sum"
                    label="Сумма до"
                    type="number"
                    clearable
                    @keyup.enter="load"
                  />
                </v-col>
                <v-col cols="2">
                  <v-checkbox
                    v-model="form.no_transaction"
                    label="Непривязанные"
                    @change="load"
                  />
                </v-col>
                <v-col cols="2">
                  <v-btn
                    color="primary"
                    dark
                    class="mb-2"
                    @click="load"
                  >
                    Поиск
                  </v-btn>
                </v-col>
                <v-col cols="2">
                  <v-btn
                    color="secondary"
                    dark
                    min-width="250"
                    class="mb-2"
                    @click="clear"
                  >
                    Сбросить фильтры
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </template>
        <template v-slot:expanded-item="{item, headers }">
          <td :colspan="headers.length">
            <v-row>
              <v-col cols="4">
                <b>Даты</b>:<br>
                Создание: {{ format(item.date) }}<br>
              </v-col>
              <v-col cols="4">
                <span v-if="item.payer">
                  <b>Плательщик</b>:<br>
                  {{ item.payer.name }}<br>
                  ИНН: {{ item.payer.inn }} КПП: {{ item.payer.kpp }}<br>
                  Банк: {{ item.payer.bank_name }} {{ item.payer.bic }}<br>
                  К/с: {{ item.payer.ks }}<br>
                  Р/с: {{ item.payer.rs }}
                </span>
              </v-col>
              <v-col cols="4">
                <span v-if="item.recipient">
                  <b>Получатель</b>:<br>
                  {{ item.recipient.name }}<br>
                  ИНН: {{ item.recipient.inn }} КПП: {{ item.recipient.kpp }}<br>
                  Банк: {{ item.recipient.bank_name }} {{ item.recipient.bic }}<br>
                  К/с: {{ item.recipient.ks }}<br>
                  Р/с: {{ item.recipient.rs }}
                </span>
              </v-col>
            </v-row>
          </td>
        </template>
        <template v-slot:item.sum="{item}">
          <v-chip
            :color="getSumColor(item)"
            dark
          >
            {{ Number(item.sum).money() }}
          </v-chip>
        </template>
        <template v-slot:item.transaction="{item}">
          <v-icon
            v-if="item.transaction"
            color="green"
            @click="$router.push('/transaction/list?id=' + item.transaction)"
          >
            mdi-check-bold
          </v-icon>
          <v-icon
            v-else
            color="red"
          >
            mdi-close-octagon
          </v-icon>
        </template>
        <template v-slot:item.action="{ item }">
          <v-icon
            large
            color="primary"
            class="mr-2"
            @click="sheetitem = item, sheet = true"
          >
            mdi-cog
          </v-icon>
        </template>
        <template v-slot:item.checked="{item}">
          <v-checkbox
            v-model="item.checked"
          />
        </template>
        <template v-slot:item.date="{item}">
          {{ format(item.date, true) }}<br>
        </template>
        <template v-slot:item.state="{item}">
          <v-chip
            v-if="item.state!=1"
            :color="getStateColor(item)"
            dark
          >
            {{ dict.state[item.state] }}
          </v-chip>
          <span v-else>{{ dict.state[item.state] }}</span>
        </template>
        <template v-slot:item.contract="{item}">
          <a @click="$router.push('/contract/list?id=' + item.contract_item.id)">№{{ item.contract_item.number }}/{{ format_contract_date(item.contract_item.date) }}<br>{{ format(item.contract_item.date) }}</a>
        </template>
      </v-data-table>
      <v-card-actions>
        <v-btn
          color="primary"
          text
          :disabled="loader.show"
          @click="$refs.upload.click()"
        >
          Загрузить операции
        </v-btn>
        <v-btn
          color="primary"
          min-width="300"
          @click="dialog.state.item = { ids: items.filter(a=>a.checked).map(a=>a.id), state: 1}, sheet = false, dialog.state.show = true, dialog.state.item.multiple = true"
        >
          Привязать транзакцию выбранным
        </v-btn>
        <v-btn
          :disabled="loader.show"
          color="secondary"
          min-width="500"
          @click="show_generate_transaction"
        >
          Создать транзакции по выбранным операциям
        </v-btn>
        <v-btn
          color="error"
          @click="clear_transactions"
          >!!Очистить все привязки!!</v-btn>
      </v-card-actions>
    </base-material-card>
    <v-dialog
      v-model="dialog.state.show"
      persistent
      scrollable
      max-width="50%"
    >
      <v-card class="elevation-1">
        <v-card-title class="headline">
          Привязать транзакцию
        </v-card-title>
        <v-card-text>
          <v-autocomplete
            v-model="dialog.state.item.transaction"
            :filter="transaction_filter"
            :items="select.transaction"
            item-value="id"
            label="Выберите транзакцию"
          >
            <template v-slot:item="{item}">
              <v-row>
                <v-col cols="4">
                  <b>Даты</b>:<br>
                  Создание: {{ format(item.date.create) }}<br>
                  <span v-if="item.date.process">Исполнение: {{ format(item.date.process) }}<br></span>
                  Статус: {{ format(item.state_date) }}<br>
                  Сумма: {{ item.sum }}
                </v-col>
                <v-col cols="4">
                  <span v-if="item.debet">
                    <b>Плательщик</b>:<br>
                    {{ item.debet.name }}<br>
                    ИНН: {{ item.debet.inn }} КПП: {{ item.debet.kpp }}<br>
                    Банк: {{ item.debet.bank_name }} {{ item.debet.bic }}<br>
                    К/с: {{ item.debet.ks }}<br>
                    Р/с: {{ item.debet.rs }}
                  </span>
                </v-col>
                <v-col cols="4">
                  <span v-if="item.credit">
                    <b>Получатель</b>:<br>
                    {{ item.credit.name }}<br>
                    ИНН: {{ item.credit.inn }} КПП: {{ item.credit.kpp }}<br>
                    Банк: {{ item.credit.bank_name }} {{ item.credit.bic }}<br>
                    К/с: {{ item.credit.ks }}<br>
                    Р/с: {{ item.credit.rs }}
                  </span>
                </v-col>
                <v-col cols="12">
                  {{item.description}}
                </v-col>
              </v-row>
            </template>

            <template v-slot:selection="{item}">
              <v-row>
                <v-col cols="3">
                  <b>Даты</b>:<br>
                  Создание: {{ format(item.date.create) }}
                </v-col>
                <v-col cols="3">
                  <span v-if="item.debet">
                    <b>Плательщик</b>:<br>
                    {{ item.debet.name }}
                  </span>
                </v-col>
                <v-col cols="3">
                  <span v-if="item.credit">
                    <b>Получатель</b>:<br>
                    {{ item.credit.name }}
                  </span>
                </v-col>
                <v-col cols="3">
                  Сумма: {{ item.sum }}
                </v-col>
              </v-row>
            </template>
          </v-autocomplete>
        </v-card-text>
        <v-card-actions class="grey lighten-4">
          <v-btn
            color="primary"
            flat
            @click="dialog.state.show = false"
          >
            Назад
          </v-btn>
          <v-spacer />
          <v-btn
            color="red"
            flat
            @click="changeState"
          >
            Сохранить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-bottom-sheet v-model="sheet">
      <v-list>
        <v-list-group v-model="sheetmenu">
          <v-list-item slot="activator">
            <v-list-item-action>
              <v-icon>mdi-build</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Действия</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="dialog.state.item = { id: sheetitem.id, state: sheetitem.state || 1}, sheet = false, dialog.state.show = true, dialog.state.item.multiple = false">
            <v-list-item-content>
              Привязать транзакцию
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>
    </v-bottom-sheet>
    <v-dialog
      v-model="dialog.transaction.show"
      persistent
    >
      <transaction-form
        :create="dialog.transaction.create"
        :id="dialog.transaction.id"
        :view="dialog.transaction.view"
        :change="dialog.transaction.change"
        :show="dialog.transaction.show"
        @create="create_transaction"
        @close="dialog.transaction.show = false"
      />
    </v-dialog>
    <v-dialog
      v-model="dialog.other.show"
      persistent
      scrollable
      max-width="50%"
    >
    <v-card>
      <v-card-title>Выберите тип транзакции</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="4">
                  <v-select
                    v-model="dialog.other.type"
                    label="Тип транзакции"
                    :items="select.type"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="12"
                >
                  <v-autocomplete
                    v-model="dialog.other.contract"
                    :filter="contract_filter"
                    :items="select.contract"
                    item-value="id"
                    label="Выберите договор"
                    clearable
                  >
                    <template v-slot:item="{item}">
                      {{ item.number }}/{{ item.date_number }} от {{ item.date_formatted }}<br>
                      {{item.owner.surname}}  {{item.owner.name}}  {{item.owner.patronymic}}
                    </template>

                    <template v-slot:selection="{item}">
                      {{ item.number }}/{{ item.date_number }} от {{ item.date_formatted }}
                    </template>
                  </v-autocomplete>
                </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-row>
          <v-col cols="6">
            <v-btn
              color="error"
              @click="dialog.other.show = false"
              >
              <span class="mx-10">
                Назад
              </span>
            </v-btn>
          </v-col>
          <v-col cols="6" class="text-right">
            <v-btn
              color="success"
              @click="generate_transaction"
              :disabled="!dialog.other.type"
              >
              <span class="mx-10">
                Создать
              </span>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
    </v-dialog>
    <input
      ref="upload"
      type="file"
      multiple="true"
      style="display: none;"
      @change="async_upload_files"
    >
  </v-container>
</template>

<script>
  import TransactionForm from './components/Transaction-form.vue'
  import moment from 'moment'
  import $ from 'jquery'
  export default {
    name: 'DashboardDataTables',
    components: { TransactionForm },
    data: () => ({
      datatable_footer: {
        itemsPerPageAllText: 'Все',
        itemsPerPageText: 'Показывать по', pageText: 'из'
      },
      loader: {
        show: false,
      },
      dialog: {
        transaction: {
          show: false,
          create: false,
          view: false,
          id: '',
        },
        state: {
          item: {},
          show: false,
        },
        other: {
          show: false,
          type: 0
        }
      },
      sheet: false,
      sheetmenu: true,
      sheetitem: {
        docs: [],
      },
      headers: [
        {
          sortable: false,
          text: '',
          value: 'action',
        },
        {
          text: '',
          value: 'checked',
        },
        {
          text: 'Дата',
          value: 'date',
          width: 150,
        },
        {
          text: 'Сумма',
          value: 'sum',
          width: 150,
        },
        {
          text: 'Назначение',
          value: 'description',
        },
        {
          text: 'Наименование плательщика',
          value: 'payer.name',
        },
        {
          text: 'Наименование получателя',
          value: 'recipient.name',
        },
        {
          text: '',
          value: 'transaction',
        },
      ],
      items: [],
      search: undefined,
      form: {
        date_create: {
          from: '',
          to: '',
        },
        date_process: {
          from: '',
          to: '',
        },
        state: 0,
        deleted: false,
        no_transaction: true,
      },
      select: {
        state: [
          { value: 1, text: 'Новая' },
          { value: 2, text: 'Исполнена' },
          { value: 3, text: 'Удалена по расторжению договора' },
          { value: 8, text: 'Удалена' },
        ],
        direction: [
          { value: 1, text: 'Приход' },
          { value: 2, text: 'Расход' },
        ],
        type: [],
        contract: [],
      },
      dict: {
        state: {
          1: 'Новая',
          2: 'Исполнена',
          3: 'Удалена по расторжению договора',
          8: 'Удалена',
        },
        direction: {
          1: 'Приход',
          2: 'Расход',
        },
        type: {},
        kind: {
          1: 'Оформление документов',
          2: 'Договор Цессии',
        },
      },
    }),
    mounted: function () {
      this.form.date_create.from = moment().format('YYYY-MM-DD')
      this.form.date_create.to = moment().format('YYYY-MM-DD')
      this.load()
      for (let x in this.$store.state.dict.transaction_type) {
        this.select.type.push({ value: Number(x), text: this.$store.state.dict.transaction_type[x].name, direction: Number(this.$store.state.dict.transaction_type[x].direction) })
      }
      this.axios.post('/api/contract/get', { nofill: true })
        .then(result => {
          if (!result.data.error) {
            this.select.contract = result.data.data
            for (let x in this.select.contract) {
              this.select.contract[x].date_formatted = moment(this.select.contract[x].date).format('DD.MM.YYYY')
              this.select.contract[x].owner.birthday = moment(this.select.contract[x].owner.birthday).format('DD.MM.YYYY')
              this.select.contract[x].date_number = moment(this.select.contract[x].date).format('DDMM')
              this.select.contract[x].kind_string = this.dict.kind[this.select.contract[x].kind]
            }
          }
        })
        .catch(e => {
          console.log(e)
          this.$store.commit('snackbar', 'Ошибка при получении данных')
        })
      this.axios.post('/api/transaction/list', {})
        .then(result => {
          if (!result.data.error) {
            this.select.transaction = result.data.data
            for (let x in this.select.transaction) {
              if (this.select.transaction[x].contract_item) {
                this.select.transaction[x].contract_item.date_formatted = moment(this.select.transaction[x].contract_item.date).format('DD.MM.YYYY')
                this.select.transaction[x].contract_item.owner.birthday = moment(this.select.transaction[x].contract_item.owner.birthday).format('DD.MM.YYYY')
                this.select.transaction[x].contract_item.date_number = moment(this.select.transaction[x].contract_item.date).format('DDMM')
                this.select.transaction[x].contract_item.kind_string = this.dict.kind[this.select.transaction[x].contract_item.kind]
              }
            }
          }
        })
        .catch(e => {
          console.log(e)
          this.$store.commit('snackbar', 'Ошибка при получении данных')
        })
    },
    methods: {
      contract_filter: function (item, query, text) {
        if (item.number.toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        if (item.date_formatted.toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        if (item.date_number.toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        if (query.indexOf('/') > -1) {
          if (item.number.toUpperCase().indexOf(query.toUpperCase().substring(0, 3)) > -1 &&
            item.date_number.toUpperCase().indexOf(query.toUpperCase().substring(4)) > -1
          ) return true
        }
        return false
      },
      clear_transactions: function() {
        this.axios.post('/api/transaction/clear', {})
          .then(response=> {
              if (response.data.error) {
                this.$store.commit('snackbar', 'Ошибка при сохранении данных')
              } else {
                this.$store.commit('snackbar', 'Успешно')
              }
          })
          .catch(e=>console.log(e))
      },
      clear: function () {
        this.form = {
          date_create: {
            from: '',
            to: '',
          },
          date_process: {
            from: '',
            to: '',
          },
          state: 0,
          deleted: false,
          no_transaction: true,
        }
        this.form.date_create.from = moment().format('YYYY-MM-DD')
        this.form.date_create.to = moment().format('YYYY-MM-DD')
      },
      transaction_filter: function (item, query, text) {
        if (item.description && item.description.toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        if (item.sum && String(item.sum).toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        if (item.debet && item.debet && item.debet.name && item.debet.name.toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        if (item.credit && item.credit && item.credit.name && item.credit.name.toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        if (item.contract_item) {
          return this.contract_filter(item.contract_item, query, text)
        }
        return false
      },
      async_upload_files: async function (event) {
        console.log('upload')
        const files = event.target.files
        this.loader.show = true
        this.loader.show = true
        for (let i = 0; i < files.length; i++) {
          await this.async_upload(files[i])
        }
        this.loader.show = false
      },
      async_upload: async function (file) {
        if (file) {
          let data = new FormData()
          data.append('file', file)
          await this.axios
            .post('/api/transaction/upload/', data, {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            })
            .then(response => {
              if (response.data.error) {
                this.$store.commit('snackbar', 'Ошибка при сохранении данных')
              } else {
                this.load()
              }
            })
            .catch(error => {
              this.$store.commit('snackbar', error || 'Ошибка при сохранении данных')
            })
        }
      },
      getSumColor: function (item) {
        if (item.direction == 1) return 'green'
        return 'red'
      },
      getStateColor: function (item) {
        return 'green'
      },
      format: function (date, short) {
        if (short) return moment(date).format('DD.MM.YYYY')
        return moment(date).format('DD.MM.YYYY HH:mm')
      },
      format_contract_date: function (date) {
        return moment(date).format('DDMM')
      },
      create_transaction: function (data) {
        this.axios.post('/api/transaction/create', data)
          .then(result => {
            if (!result.data.error) {
              this.dialog.transaction.show = false
              this.load()
            }
          })
          .catch(e => {
            this.$store.commit('snackbar', 'Ошибка при обновлении данных')
          })
      },
      changeState: function () {
        this.axios.post('/api/transaction/operations/set', this.dialog.state.item)
          .then(result => {
            if (!result.data.error) {
              this.dialog.state.show = false
              this.load()
            }
          })
          .catch(e => {
            this.dialog.state.show = false
            this.$store.commit('snackbar', 'Ошибка при обновлении данных')
          })
      },
      getDoc: function (item) {
        let form = $('<form>', {
          target: '_blank',
          action: '/api/common/document',
          method: 'post',
        })
        form.append(
          $('<input>', {
            type: 'hidden',
            value: item.id,
            name: 'id',
          })
        )
        form.appendTo('body').submit()
      },
      show_generate_transaction: function() {
        this.dialog.other.show = true
        this.dialog.other.type = 0
        this.dialog.other.contract = ""
      },
      generate_transaction: function () {
        this.loader.show = true
        this.axios.post('/api/transaction/generate', { contract: this.dialog.other.contract, type: this.dialog.other.type, items: this.items.filter(a => a.checked) })
          .then(result => {
            this.loader.show = false
            if (!result.data.error) {
              this.load()
              this.dialog.other.show = false
            } else {
              this.$store.commit('snackbar', result.data.data)
            }
          })
          .catch(e => {
            this.loader.show = false
            console.log(e)
            this.$store.commit('snackbar', 'Ошибка при получении данных')
          })
      },
      load: function () {
        this.axios.post('/api/transaction/operations/list', this.form)
          .then(result => {
            if (!result.data.error) {
              this.items = result.data.data
            }
          })
          .catch(e => {
            console.log(e)
            this.$store.commit('snackbar', 'Ошибка при получении данных')
          })
      },
    },
  }
</script>
